import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div
  class="d-lightbox__body"
  tabindex="-1"
  {{on "touchstart" @onTouchstart passive=true capture=true}}
  {{on "touchend" @onTouchend passive=true capture=true}}
  {{on "click" @toggleZoom passive=true}}
>
  {{#if @shouldDisplayMainImageArrows}}
    <DButton
      {{on "click" @showPreviousItem passive=true capture=true}}
      @title="experimental_lightbox.buttons.previous"
      @icon={{@previousButtonIcon}}
      @ariaHidden="true"
      class="d-lightbox__previous-button btn-transparent"
    />
  {{/if}}
  {{#if @isLoading}}
    <span class="d-lightbox__loading-spinner">
      {{loading-spinner size="large"}}
    </span>
  {{else if @hasLoadingError}}
    <span class="d-lightbox__error-message">
      <DButton
        {{on "click" @reloadImage passive=true capture=true}}
        @title="experimental_lightbox.buttons.redo"
        @icon="redo"
        class="d-lightbox__retry-button btn-flat"
      />
      <span>{{i18n "experimental_lightbox.image_load_error"}}</span>
    </span>
  {{else if @isZoomed}}
    <div
      class="d-lightbox__zoomed-image-container"
      tabindex="-1"
      {{did-insert @centerZoomedBackgroundPosition}}
      {{on "mousemove" @zoomOnMouseover passive=true capture=true}}
    ></div>
  {{else}}
    <DLightbox::Backdrop @close={{@close}} />
    <img
      aria-hidden="true"
      draggable="false"
      fetchPriority="high"
      decoding="async"
      tabindex="-1"
      class="d-lightbox__main-image"
      src={{@currentItem.fullsizeURL}}
    />
  {{/if}}
  {{#if @shouldDisplayMainImageArrows}}
    <DButton
      {{on "click" @showNextItem passive=true capture=true}}
      @title="experimental_lightbox.buttons.next"
      @icon={{@nextButtonIcon}}
      @ariaHidden="true"
      class="d-lightbox__next-button btn-flat"
    />
  {{/if}}
</div>
*/
{
  "id": "cTlUwFoT",
  "block": "[[[11,0],[24,0,\"d-lightbox__body\"],[24,\"tabindex\",\"-1\"],[4,[38,0],[\"touchstart\",[30,1]],[[\"passive\",\"capture\"],[true,true]]],[4,[38,0],[\"touchend\",[30,2]],[[\"passive\",\"capture\"],[true,true]]],[4,[38,0],[\"click\",[30,3]],[[\"passive\"],[true]]],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"    \"],[8,[39,2],[[24,0,\"d-lightbox__previous-button btn-transparent\"],[4,[38,0],[\"click\",[30,6]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.previous\",[30,5],\"true\"]],null],[1,\"\\n\"]],[]],null],[41,[30,7],[[[1,\"    \"],[10,1],[14,0,\"d-lightbox__loading-spinner\"],[12],[1,\"\\n      \"],[1,[28,[35,3],null,[[\"size\"],[\"large\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,8],[[[1,\"    \"],[10,1],[14,0,\"d-lightbox__error-message\"],[12],[1,\"\\n      \"],[8,[39,2],[[24,0,\"d-lightbox__retry-button btn-flat\"],[4,[38,0],[\"click\",[30,9]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\"],[\"experimental_lightbox.buttons.redo\",\"redo\"]],null],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,4],[\"experimental_lightbox.image_load_error\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,10],[[[1,\"    \"],[11,0],[24,0,\"d-lightbox__zoomed-image-container\"],[24,\"tabindex\",\"-1\"],[4,[38,5],[[30,11]],null],[4,[38,0],[\"mousemove\",[30,12]],[[\"passive\",\"capture\"],[true,true]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,6],null,[[\"@close\"],[[30,13]]],null],[1,\"\\n    \"],[10,\"img\"],[14,\"aria-hidden\",\"true\"],[14,\"draggable\",\"false\"],[14,\"fetchPriority\",\"high\"],[14,\"decoding\",\"async\"],[14,\"tabindex\",\"-1\"],[14,0,\"d-lightbox__main-image\"],[15,\"src\",[30,14,[\"fullsizeURL\"]]],[12],[13],[1,\"\\n  \"]],[]]]],[]]]],[]]],[41,[30,4],[[[1,\"    \"],[8,[39,2],[[24,0,\"d-lightbox__next-button btn-flat\"],[4,[38,0],[\"click\",[30,16]],[[\"passive\",\"capture\"],[true,true]]]],[[\"@title\",\"@icon\",\"@ariaHidden\"],[\"experimental_lightbox.buttons.next\",[30,15],\"true\"]],null],[1,\"\\n\"]],[]],null],[13]],[\"@onTouchstart\",\"@onTouchend\",\"@toggleZoom\",\"@shouldDisplayMainImageArrows\",\"@previousButtonIcon\",\"@showPreviousItem\",\"@isLoading\",\"@hasLoadingError\",\"@reloadImage\",\"@isZoomed\",\"@centerZoomedBackgroundPosition\",\"@zoomOnMouseover\",\"@close\",\"@currentItem\",\"@nextButtonIcon\",\"@showNextItem\"],false,[\"on\",\"if\",\"d-button\",\"loading-spinner\",\"i18n\",\"did-insert\",\"d-lightbox/backdrop\"]]",
  "moduleName": "discourse/components/d-lightbox/body.hbs",
  "isStrictMode": false
});